import { render, staticRenderFns } from "./FundsOperationsTable.vue?vue&type=template&id=f5f77032&"
import script from "./FundsOperationsTable.vue?vue&type=script&lang=js&"
export * from "./FundsOperationsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports